import moment from 'moment'

export const formatDate = date => {
  if (moment(date).format('YYYY') === String(new Date().getFullYear())) {
    return moment(date).format('MMM D h:mm a')
  }

  return moment(date).format('MMM D YYYY')
}
